function getDefaultIdentifier() {
    return {
        val: '',
        type: [],
    };
}
export default getDefaultIdentifier;
